//Built-in libraries

//Third party libraries

//Custom components
import Button from '@/components/UI/Button';
import { HookFileInput } from '@/components/UI/HookForm/Form/File';
//Services
import { useApplicationFormContext } from '@/features/ApplicationForm/ApplicationFormProvider';

//STP Libraries

//Assets and Miscellaneous

//Component Begin

export default function Attachments() {
  const { setCurrentStep } = useApplicationFormContext();

  return (
    <div className='sm:rounded-r-md sm:overflow-hidden'>
      <div className='py-6 px-4 space-y-6 sm:p-6'>
        <div>
          <h3 className='text-lg leading-6 font-medium text-green-500'>Attachments</h3>
        </div>
        <p className='py-4'>Please provide the following documents</p>
        <div className='grid grid-cols-6 gap-6'>
          <div className='col-span-4'>
            <HookFileInput name='step2.selectedFiles' label='MHT' id='selectedFiles' multiple />
          </div>
          <div className='col-span-2 self-end'>
            <a
              className='underline text-blue-600'
              href='https://assets.seinterminal.com/files/MHT__Compliance_Forms_Projectreview.pdf'
              target='_blank'
              rel='noreferrer noopener'
            >
              Click to Download MHT Form
            </a>
          </div>
          <div className='col-span-4'>
            <HookFileInput name='step2.selectedFiles' label='Insurance' id='selectedFiles' multiple />
          </div>
          <div className='col-span-2 self-end'>
            <a
              className='underline text-blue-600'
              href='https://assets.seinterminal.com/files/MHT__Compliance_Forms_Projectreview.pdf'
              target='_blank'
              rel='noreferrer noopener'
            >
              Click to Download Sample Insurance
            </a>
          </div>
          <div className='col-span-4'>
            <HookFileInput name='step2.selectedFiles' label='Evidence of Grant Match' id='selectedFiles' multiple />
          </div>
        </div>
        <div className='flex gap-4 justify-end mt-5'>
          <Button label='Previous' btnStyle='neutral' type='button' onClick={() => setCurrentStep((prev) => prev - 1)} />
          <Button label='Next' btnStyle='primary' type='submit' />
        </div>
      </div>
    </div>
  );
}
